import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";

import PublicLayout from "@/components/public/PublicLayout";
import Home from "@/pages/public/Home";
import EntityPage from "@/pages/public/EntityPage";
import BlogIndex from "@/pages/public/BlogIndex";
import BlogPost from "@/pages/public/BlogPost";
import LegalPage from "@/pages/public/LegalPage";
import NotFound from "@/pages/public/NotFound";

import ProtectedRoute from "@/components/admin/ProtectedRoute";
import Login from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Entities from "@/pages/admin/Entities";
import EntityEditor from "@/pages/admin/EntityEditor";
import Leads from "@/pages/admin/Leads";
import Redirects from "@/pages/admin/Redirects";
import Audit from "@/pages/admin/Audit";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SiteProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/tr" replace />} />

            <Route path="/sbt-panel-7391/login" element={<Login />} />
            <Route path="/sbt-panel-7391" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="entities" element={<Entities />} />
              <Route path="entities/:entityId" element={<EntityEditor />} />
              <Route path="leads" element={<Leads />} />
              <Route path="redirects" element={<Redirects />} />
              <Route path="audit" element={<Audit />} />
            </Route>

            <Route path="/:lang" element={<PublicLayout />}>
              <Route index element={<Home />} />
              <Route path="blog" element={<BlogIndex />} />
              <Route path="blog/:postSlug" element={<BlogPost />} />
              <Route path="privacy" element={<LegalPage type="privacy" />} />
              <Route path="terms" element={<LegalPage type="terms" />} />
              <Route path=":slug" element={<EntityPage />} />
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster position="top-right" richColors theme="dark" />
        </SiteProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
